import { render, staticRenderFns } from "./NeopassTour.vue?vue&type=template&id=c805419c&"
import script from "./NeopassTour.vue?vue&type=script&lang=js&"
export * from "./NeopassTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports